"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CurrencyMysqlHandler", {
    enumerable: true,
    get: function() {
        return CurrencyMysqlHandler;
    }
});
const _decimalmysqlhandler = require("../decimal/decimal.mysql.handler");
const _currencygeneralhandler = require("./currency.general.handler");
let CurrencyMysqlHandler = class CurrencyMysqlHandler extends _decimalmysqlhandler.DecimalMysqlHandler {
    constructor(...args){
        super(...args), this.currencyGeneralHandler = new _currencygeneralhandler.CurrencyGeneralHandler(), this.parseUserInput = this.currencyGeneralHandler.parseUserInput;
    }
};
